import { mapActions, mapMutations } from "vuex";

export const answerQuestionMixins = {
  data() {
    return {
      formData: {
        id: null,
        lessonId: null,
        lessonName: "",
        answer: "",
        materialUrls: [],
        question: "",
      },
      rules: {
        answer: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions("courseCenter", [
      "saveLessonQuestion",
      "getLessonQuestionResponseList",
    ]),
    ...mapMutations("courseCenter", ["setData"]),
    //表单清空
    clearForm() {
      this.formData = {
        id: null,
        lessonId: null,
        answer: "",
        lessonName: "",
        materialUrls: [],
      };
    },
    async handleCommit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.saveLessonQuestion({
            id: this.formData.id,
            lessonId: this.formData.lessonId,
            answer: this.formData.answer,
          });
          this.$message.success("提交成功");
          this.setData({
            key: "answerQuestionModalVisible",
            value: false,
          });
          await this.getLessonQuestionResponseList();
        }
      });
    },
  },
};
